import { MButton } from '@assets/mui/@material-extend';
import { useBitrix } from '@context/useBitrixUser/useBitrix';
import Typography from '@mui/material/Typography';
import { companyProfileService } from '@services/requests/companyProfileService';
import { RepresentativeData } from '@services/requests/companyProfileService/types/representativesData';
import React, { useState } from 'react';

import { ChangeNotification } from '../../ChangeNotification';
import { DefaultRepresentativesItem } from './DefaultRepresentativesItem';
import { RepresentativesItem } from './RepresentativesItem';
import { RepresentativesListModuleStyledContainer } from './StyledComponents';
import { RepresentativesFormFields } from './types';

interface RepresentativesListModuleProps {
  representativeData: RepresentativeData;
}

function RepresentativesListModule({ representativeData }: RepresentativesListModuleProps) {
  const [representativesList, setRepresentativesList] = useState<RepresentativesFormFields[]>(() =>
    Object.values(representativeData.users).map((user) => ({
      id: user.id,
      fullName: user.fields.full_name.value,
      email: user.fields.email.value,
      accessRight: user.fields.role.value === true ? 1 : 0,
      workingWithApplications: user.fields.work_type.value === true ? 1 : 0,
    }))
  );
  const [isChangeNotificationOpen, setIsChangeNotificationOpen] = useState<boolean>(false);

  const { useBitrixUser } = useBitrix();
  const [{ bitrixUser }] = useBitrixUser().useState();

  const addRepresentativeItemHandler = () => {
    setRepresentativesList((prevState) => [...prevState, new DefaultRepresentativesItem()]);
  };

  const removeRepresentativeItemHandler = async (
    representativeIndex: number,
    id: string,
    onError: (errors: string[]) => void
  ) => {
    if (representativesList.length === 1) {
      return;
    }

    if (!id.includes('new-representative')) {
      const result = await companyProfileService().DeleteRepresentative(bitrixUser.id, id);

      if (!result.success) {
        onError(result.errors ?? []);
        return;
      }
    }

    setIsChangeNotificationOpen(true);
    setRepresentativesList((prevState) => [
      ...prevState.slice(0, representativeIndex),
      ...prevState.slice(representativeIndex + 1),
    ]);
  };

  return (
    <>
      <RepresentativesListModuleStyledContainer>
        {representativesList.map((item, index) => {
          return (
            <RepresentativesItem
              key={item.id}
              index={index}
              representativesItem={item}
              representativeData={representativeData}
              totalCount={representativesList.length}
              onRemoveRepresentativesItem={removeRepresentativeItemHandler}
            />
          );
        })}
        <div>
          <MButton
            className={'representative-tab-button'}
            variant={'outlined'}
            color={'secondary'}
            onClick={addRepresentativeItemHandler}
          >
            <Typography color={'#3460B4'} fontSize={16} fontWeight={600}>
              {representativeData.messages.btn_add}
            </Typography>
          </MButton>
        </div>
      </RepresentativesListModuleStyledContainer>

      <ChangeNotification
        needReviewType={false}
        isOpen={isChangeNotificationOpen}
        onClose={() => setIsChangeNotificationOpen(false)}
      />
    </>
  );
}
export { RepresentativesListModule };
